import { z } from 'zod'
import { optionalText, requiredText } from './common'

export const projectInputSchema = z.object({
  /** Free text: the developer is usually not a client of the office. */
  developerName: optionalText(200),
  name: optionalText(200),
  hebrewName: requiredText(200, 'שם הפרויקט בעברית הוא שדה חובה'),
  gush: optionalText(30),
  parcel: optionalText(30),
  city: optionalText(100),
  street: optionalText(150),
})

export type ProjectInput = z.infer<typeof projectInputSchema>

export const projectQuerySchema = z.object({
  search: optionalText(200),
})

export type ProjectQuery = z.infer<typeof projectQuerySchema>

export type ProjectDto = {
  id: string
  developerName: string | null
  name: string | null
  hebrewName: string
  gush: string | null
  parcel: string | null
  city: string | null
  street: string | null
  createdAt: string
  updatedAt: string
}
